class LocalJPPC {
  constructor({ gm, mainUrl }) {
    this.path = 'jppc'
    this.gm = gm || 'nxsignin'
    this.mainUrl = mainUrl || 'https://jp.nexon.com'
    this.signinPath = `/signin/insign?gm=${this.gm}&redirect=`
    this.signoutPath = '/common/logout?redirect='
    this.signupPath = `/regist?gm=${this.gm}&redirect=`
    this.accountPath = '/mypage'
  }

  get signinUrl() {
    return this.mainUrl + this.signinPath
  }

  get signoutUrl() {
    return this.mainUrl + this.signoutPath
  }

  get signupUrl() {
    return this.mainUrl + this.signupPath
  }

  get accountUrl() {
    return this.mainUrl + this.accountPath
  }
}

export default LocalJPPC
